import {
    SIGNIN_USUARIO,
    SIGNIN_USUARIO_SUCCESS,
    SIGNIN_USUARIO_FAILURE,

    LOGOUT_USER,

    FETCH_USUARIO,
    FETCH_USUARIO_SUCCESS,
    FETCH_USUARIO_FAILURE,

    FETCH_USUARIOS,
    FETCH_USUARIOS_SUCCESS,
    FETCH_USUARIOS_FAILURE

} from '../actions/usuario';

const INITIAL_STATE = {data: null, error: null, loading: false};

export default function (state = INITIAL_STATE, action) {
    let error;

    switch (action.type) {
        case SIGNIN_USUARIO:
            return {...state, data: null, error: null, loading: true};
        case SIGNIN_USUARIO_SUCCESS:
            return {...state, data: action.payload, error: null, loading: false};
        case SIGNIN_USUARIO_FAILURE:
            return {...state, data: null, error: action.payload.message, loading: false};

        case LOGOUT_USER:
            return {...state, signOut: true};

        case FETCH_USUARIO:
            return {...state, data: null, error: null, loading: true};
        case FETCH_USUARIO_SUCCESS:
            return {...state, data: action.payload, error: null, loading: false};
        case FETCH_USUARIO_FAILURE:
            error = action.payload.data || {message: action.payload.message};
            return {...state, data: null, error: error, loading: false};

        case FETCH_USUARIOS:
            return {...state, data: null, error: null, loading: true};
        case FETCH_USUARIOS_SUCCESS:
            return {...state, data: action.payload, error: null, loading: false};
        case FETCH_USUARIOS_FAILURE:
            error = action.payload.data || {message: action.payload.message};
            return {...state, data: null, error: error, loading: false};

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// src/reducers/usuario.js